/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap/modal/modal-window';
const styles_NgbModalWindow:any[] = ([] as any[]);
export const RenderType_NgbModalWindow:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_NgbModalWindow,data:{}});
export function View_NgbModalWindow_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),4,'div',[['role','document']],[[8,'className',0]],(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class','modal-content']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵncd((null as any),0),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
          i0.ɵted((null as any),['\n    ']))],(null as any),(_ck,_v) => {
    var _co:i1.NgbModalWindow = _v.component;
    const currVal_0:any = ('modal-dialog' + (_co.size? (' modal-' + _co.size): ''));
    _ck(_v,1,0,currVal_0);
  });
}
export function View_NgbModalWindow_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ngb-modal-window',
      [['role','dialog'],['style','display: block;'],['tabindex','-1']],[[8,'className',
          0]],[[(null as any),'keyup.esc'],[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('keyup.esc' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).escKey($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('click' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).backdropClick($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },View_NgbModalWindow_0,RenderType_NgbModalWindow)),i0.ɵdid(4440064,(null as any),
      0,i1.NgbModalWindow,[i0.ElementRef,i0.Renderer2],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(_ck,_v) => {
        const currVal_0:any = ('modal fade show' + (i0.ɵnov(_v,1).windowClass? (' ' + i0.ɵnov(_v,
            1).windowClass): ''));
        _ck(_v,0,0,currVal_0);
      });
}
export const NgbModalWindowNgFactory:i0.ComponentFactory<i1.NgbModalWindow> = i0.ɵccf('ngb-modal-window',
    i1.NgbModalWindow,View_NgbModalWindow_Host_0,{backdrop:'backdrop',keyboard:'keyboard',
        size:'size',windowClass:'windowClass'},{dismissEvent:'dismiss'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvbW9kYWwvbW9kYWwtd2luZG93Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvbW9kYWwvbW9kYWwtd2luZG93LmQudHMiLCJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL0BuZy1ib290c3RyYXAvbmctYm9vdHN0cmFwL21vZGFsL21vZGFsLXdpbmRvdy5kLnRzLk5nYk1vZGFsV2luZG93Lmh0bWwiLCJuZzovLy92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL3ZlbnlvdS1zdHJpcGUvbm9kZV9tb2R1bGVzL0BuZy1ib290c3RyYXAvbmctYm9vdHN0cmFwL21vZGFsL21vZGFsLXdpbmRvdy5kLnRzLk5nYk1vZGFsV2luZG93X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGRpdiBbY2xhc3NdPVwiJ21vZGFsLWRpYWxvZycgKyAoc2l6ZSA/ICcgbW9kYWwtJyArIHNpemUgOiAnJylcIiByb2xlPVwiZG9jdW1lbnRcIj5cbiAgICAgICAgPGRpdiBjbGFzcz1cIm1vZGFsLWNvbnRlbnRcIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC9kaXY+XG4gICAgPC9kaXY+XG4gICAgIiwiPG5nYi1tb2RhbC13aW5kb3c+PC9uZ2ItbW9kYWwtd2luZG93PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLDJDQUNJO01BQUE7TUFBQSw0Q0FBK0U7TUFDM0U7VUFBQTthQUEyQixrQkFBK0IsMkNBQ3hEO2lCQUFBOztJQUZEO0lBQUwsV0FBSyxTQUFMOzs7O29CQ0RKO01BQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsMkRBQUE7TUFBQTs7UUFBQTs7UUFBQTtZQUFBO1FBQUEsV0FBQSxTQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/@ng-bootstrap/ng-bootstrap/modal/modal-window.ngfactory.ts